import { firebase_app } from '../Config/Config';
import { getFunctionUrl } from './apiHost';

export const getReportingProxyUrl = (resource, params = new URLSearchParams()) => {
  const query = new URLSearchParams(params);
  query.set('resource', resource);

  const ordered = new URLSearchParams();
  ordered.set('resource', query.get('resource'));
  query.forEach((value, key) => {
    if (key !== 'resource') ordered.append(key, value);
  });

  // The authenticated proxy is deployed with the app on both production domains.
  // Keep browser requests on that origin so Authorization needs no cross-origin preflight.
  const proxyUrl = process.env.NODE_ENV === 'production'
    ? '/api/reporting'
    : getFunctionUrl('/api/reporting');
  return `${proxyUrl}?${ordered.toString()}`;
};

export const getReportingProxyHeaders = async (accept = 'application/json') => {
  const user = firebase_app.auth().currentUser;
  if (!user) {
    throw new Error('Votre session a expiré. Veuillez vous reconnecter.');
  }

  const idToken = await user.getIdToken();
  return {
    Accept: accept,
    Authorization: `Bearer ${idToken}`,
  };
};
